import React, { useState } from 'react';
import SwitchOne from '../../components/SwitchOne/SwitchOne.component';
import {
  Card,
  CardContent,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useStyles } from './Context.styles';
import { ButtonOne } from '../../components/ButtonOne/ButtonOne.component';
import { useTranslation } from 'react-i18next';

function Context() {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const [contextState, setContextState] = useState({
    checkedExaminer: true,
    checkedCommisionEmployee: false,
    checkedAdmin: false,
  });

  const [examinationSession, setExaminationSession] = useState<string>('');
  const [assesmentSession, setAssesmentSession] = useState<string>('');
  const [isValidInput, setIsValidInput] = useState<boolean>(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContextState({
      ...contextState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeExamSession = (event: any) => {
    setExaminationSession(event.target.value);
    setIsValidInput(true);
  };

  const handleChangeAssessmentSession = (event: any) => {
    setAssesmentSession(event.target.value);
    setIsValidInput(true);
  };

  const handleSubmit = () => {
    history.push('/');
  };

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <svg
          width="1600"
          height="505"
          viewBox="0 0 1400 505"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="translate(0,150)"
        >
          <path
            d="M-1107.23 216.827C-953.576 284.863 -768.043 275.088 -622.084 192.553C-535.33 143.007 -462.074 69.4837 -367.99 30.8179C-265.509 -11.1003 -153.247 -5.84831 -45.8054 25.4301C10.9784 41.969 66.4341 65.7088 118.118 93.0228C167.842 119.274 216.415 149.233 264.472 178.99C326.522 217.776 388.47 256.819 454.198 286.946C490.49 303.497 527.888 317.215 566.337 327.483C630.209 344.118 694.87 350.373 759.169 349.954C861.932 349.12 966.252 331.376 1072.42 313.464C1177.26 295.922 1282.35 278.48 1386.33 269.214C1479.48 261.062 1572.38 259.641 1665.38 271.623C1677.82 273.217 1690.17 275.069 1702.66 277.278C1759.09 287.143 1814.44 304.31 1859.18 337.227C1913.9 377.305 1948.45 445.434 1930.85 504.176"
            stroke="#C3C6FF"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        <svg
          width="1236"
          height="2892"
          viewBox="0 0 1236 2892"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="translate(800, -1100)"
        >
          <path
            d="M846.675 2871.59C857.585 2811.83 872.874 2728.72 905.02 2644.89C937.153 2560.51 982.3 2476.63 1030.01 2395.44C1041.94 2375.22 1054.13 2354.7 1066.35 2334.75C1102.7 2274.61 1139.88 2214.44 1167.26 2149.55C1170.38 2142 1173.51 2134.45 1176.36 2126.91C1206.65 2046.17 1219.05 1958.43 1206.94 1874.91C1190.77 1762.45 1134.33 1665.69 1062.15 1580.95C978.851 1483.22 866.282 1398.42 762.456 1330.82C715.743 1300.21 671.938 1275.05 629.16 1257.62C567.086 1232.1 494.138 1214.06 463.392 1137.39C447.118 1096.31 450.586 1048.36 461.335 1003.81C465.594 986.552 470.703 970.097 476.677 955.003C498.236 900.499 526.148 856.345 541.745 806.697C555.295 763.466 558.373 711.097 534.272 666.899C530.5 660.079 526.182 653.551 521.318 647.313C476.708 590.916 391.674 576.229 318.288 573.416C265.12 571.465 210.641 572.314 160.478 558.113C140.968 552.529 121.954 544.719 104.238 533.555C36.4618 490.758 1.84359 403.394 10.5897 324.044C19.3287 244.417 69.065 177.567 128.061 126.526C202.205 62.0908 304.048 20.4589 407.52 20.561"
            stroke="white"
            strokeOpacity="0.3"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>

        <Card className={classes.root}>
          <CardContent>
            <Typography className={classes.header}>{`Wybierz kontekst pracy w ${t('global:shortNames.system')}`}</Typography>
            <FormGroup>
              <FormControlLabel
                className={classes.label}
                control={
                  <SwitchOne
                    disableRipple
                    checked={contextState.checkedExaminer}
                    onChange={handleChange}
                    name="checkedExaminer"
                    color="primary"
                  />
                }
                label="Egzaminator"
                labelPlacement="start"
              />
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="outlined-label">Sesja egzaminacyjna</InputLabel>
                <Select
                  labelId="outlined-label"
                  id="select-outlined"
                  value={examinationSession}
                  onChange={handleChangeExamSession}
                  label="Sesja egzaminacyjna"
                >
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 1 termin: 14.06.2021 r. - 27.06.2021 r.'}>
                    Semestr letni 2020/2021 1 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 2 termin: ...'}>
                    Semestr letni 2020/2021 2 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 3 termin: ...'}>
                    Semestr letni 2020/2021 3 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 4 termin: ...'}>
                    Semestr letni 2020/2021 4 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 5 termin: ...'}>
                    Semestr letni 2020/2021 5 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="select-outlined-label">Sesja oceniania</InputLabel>
                <Select
                  labelId="outlined-label"
                  id="select-outlined"
                  value={assesmentSession}
                  onChange={handleChangeAssessmentSession}
                  label="Sesja oceniania"
                >
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 1 termin: 14.06.2021 r. - 27.06.2021 r.'}>
                    Semestr letni 2020/2021 1 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 2 termin: ...'}>
                    Semestr letni 2020/2021 2 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 3 termin: ...'}>
                    Semestr letni 2020/2021 3 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 4 termin: ...'}>
                    Semestr letni 2020/2021 4 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                  <MenuItem disableRipple value={'Semestr letni 2020/2021 5 termin: ...'}>
                    Semestr letni 2020/2021 5 termin: 14.06.2021 r. - 27.06.2021 r.
                  </MenuItem>
                </Select>
              </FormControl>
              <ButtonOne className={classes.button} variant="outlined" color="primary">
                Zapisz
              </ButtonOne>
              <Divider variant="middle" className={classes.divider} />
              <FormControlLabel
                className={classes.label}
                control={
                  <SwitchOne
                    disableRipple
                    checked={contextState.checkedCommisionEmployee}
                    onChange={handleChange}
                    name="checkedCommisionEmployee"
                    color="primary"
                  />
                }
                label="Pracownik Komisji Egzaminacyjnej"
                labelPlacement="start"
              />
              <Divider variant="middle" className={classes.divider} />
              <FormControlLabel
                className={classes.label}
                control={
                  <SwitchOne
                    disableRipple
                    checked={contextState.checkedAdmin}
                    onChange={handleChange}
                    name="checkedAdmin"
                    color="primary"
                  />
                }
                label="Administrator"
                labelPlacement="start"
              />
              <Divider variant="middle" className={classes.divider} />
              <ButtonOne
                color="primary"
                variant="contained"
                onClick={() => handleSubmit()}
                disabled={!isValidInput ? true : false}
                type="submit"
                className={classes.submit}
              >
                PRZEJDŹ DALEJ
              </ButtonOne>
            </FormGroup>
          </CardContent>
        </Card>
      </div>
    </Container>
  );
}
export default Context;
